import React from 'react';
import { ITableProps } from '../../types.type';

export const Table = ({ children }: ITableProps) => (
  <table className="w-full text-left rounded-[22px] px-[16px] mt-[16px] mb-[16px] border border-blue-50 shadow-[0px_4px_10px_rgba(42,60,68,0.08)] overflow-hidden bg-surface-base">
    {children}
  </table>
);
